const $a324a3dc5f097627$export$567fc7097e064344 = ()=>{
    return Math.random().toString(36).substring(2, 9);
};


class $e823b32e1df697e6$export$16fa2f45be04daa8 {
    constructor(){
        this.id = (0, $a324a3dc5f097627$export$567fc7097e064344)();
    }
}


class $5c349c439b942f5d$export$66edb15d531635b1 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    get elapsedTime() {
        return this._elapsedTime;
    }
    set elapsedTime(value) {
        this._elapsedTime = value;
    }
    get mirror() {
        return this._mirror;
    }
    get state() {
        return this._state;
    }
    constructor(animations){
        super();
        this._elapsedTime = 0;
        this._mirror = false;
        this._state = "idle";
        this.animations = animations;
    }
    changeAnimation(state, direction) {
        if (!this.animations[state]) throw new Error(`Animation ${state} not found`);
        if (direction) this._mirror = direction === "left";
        if (this._state === state) return;
        this._state = state;
        this._elapsedTime = 0;
        this.animations[this._state].currentFrame = 0;
    }
    getAnimation() {
        return this.animations[this._state];
    }
    isDone() {
        return this.getAnimation().loop === false && this.animations[this._state].currentFrame === this.animations[this._state].frameCount - 1;
    }
}



class $fc12afeb84cfb73e$export$6191c3ac084cc81b {
    constructor(name, damage, radius, offsetX){
        this.name = name;
        this.damage = damage;
        this.radius = radius;
        this.offsetX = offsetX;
    }
}
class $fc12afeb84cfb73e$export$53aca58b69afda2 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(attacks){
        super();
        this.attacks = attacks;
    }
    getAttack(attackType) {
        return this.attacks[attackType];
    }
}



class $3d0318475a397300$export$4268a6ac59be30c1 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(minX, maxX, minY, maxY){
        super();
        this.minX = minX;
        this.maxX = maxX;
        this.minY = minY;
        this.maxY = maxY;
    }
    isInBoundary(x, y) {
        return x >= this.minX && x <= this.maxX && y >= this.minY && y <= this.maxY;
    }
}



class $805f1743fe3f6d72$export$3c9e91dc1b611d2e extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(x, y, radius){
        super();
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    isColliding(other) {
        const dx = this.x - other.x;
        const dy = this.y - other.y;
        const distance = Math.hypot(dy, dx);
        return distance < this.radius + other.radius;
    }
}



class $834cd050a1a16358$export$4e4f72cac9994c6 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(maxHealth, currentHealth){
        super();
        this.maxHealth = maxHealth;
        this.currentHealth = currentHealth;
    }
    isDead() {
        return this.currentHealth <= 0;
    }
    takeDamage(damage) {
        this.currentHealth = Math.max(0, this.currentHealth - damage);
    }
}



class $e05e29b0d9153877$export$99ca0c5cb670cc62 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.keys = {};
        this.keyStack = [];
    }
    setKeyState(key, state) {
        this.keys[key] = state;
        if (state) {
            this.keyStack.push(key);
            return;
        }
        this.keyStack = this.keyStack.filter((k)=>k !== key);
    }
    isKeyDown(key) {
        var _a;
        return (_a = this.keys[key]) !== null && _a !== void 0 ? _a : false;
    }
    getLastKey() {
        return this.keyStack.pop();
    }
}



class $67b456ed522530b1$export$2d9aa282ad3f9ac extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(x, y){
        super();
        this.x = x;
        this.y = y;
    }
}



class $f3338545e23e2b8f$export$36b8b2bbc6a3b797 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(state, direction = "right"){
        super();
        this.state = state;
        this.direction = direction;
        this.attackCooldown = 0;
    }
    getDirection() {
        return this.direction;
    }
    getState() {
        return this.state;
    }
    update(deltaTime) {
        if (this.attackCooldown <= 0) return;
        this.attackCooldown -= deltaTime;
    }
    isAttacking() {
        return this.state.includes("attack");
    }
    changeState(state, direction = this.direction) {
        if (state.includes("attack") && this.isAttacking()) return;
        if (this.state === state && this.direction === direction) return;
        this.state = state;
        this.direction = direction;
    }
    canAttack() {
        if (this.attackCooldown > 0) return false;
        this.attackCooldown = 0.5;
        return true;
    }
}



class $3250075dfba4d6bd$export$babf5140de81ae32 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(dx, dy, speed = 1){
        super();
        this.dx = dx;
        this.dy = dy;
        this.speed = speed;
    }
    isMoving() {
        return this.dx !== 0 || this.dy !== 0;
    }
    direction() {
        if (this.dx >= 0) return "right";
        return "left";
    }
}



class $321bee1b12e48a66$export$bc644a473284d944 {
    constructor(){
        this.components = new Map();
        this.id = (0, $a324a3dc5f097627$export$567fc7097e064344)();
    }
    addComponent(component) {
        this.components.set(component.constructor.name, component);
    }
    getComponent(componentType) {
        return this.components.get(componentType.name);
    }
    hasComponent(componentType) {
        return this.components.has(componentType.name);
    }
    hasComponents(componentTypes) {
        return componentTypes.every((componentType)=>this.hasComponent(componentType));
    }
    removeComponent(componentType) {
        this.components.delete(componentType.name);
    }
}


const $0bf05d3e3dd37f6f$var$idleImage = document.getElementById("player-idle");
const $0bf05d3e3dd37f6f$var$walkImage = document.getElementById("player-walk");
const $0bf05d3e3dd37f6f$var$attackOneImage = document.getElementById("player-attack-1");
const $0bf05d3e3dd37f6f$var$attackTwoImage = document.getElementById("player-attack-2");
const $0bf05d3e3dd37f6f$var$attackThreeImage = document.getElementById("player-attack-3");
const $0bf05d3e3dd37f6f$var$deadImage = document.getElementById("player-dead");
const $0bf05d3e3dd37f6f$export$b147f7238d68047 = ()=>({
        idle: {
            image: $0bf05d3e3dd37f6f$var$idleImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 4,
            frameDuration: 0.06,
            scale: 2,
            currentFrame: 0,
            anchor: {
                x: -34,
                y: -128
            },
            loop: true
        },
        walk: {
            image: $0bf05d3e3dd37f6f$var$walkImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 4,
            frameDuration: 0.06,
            scale: 2,
            currentFrame: 0,
            anchor: {
                x: -60,
                y: -128
            },
            loop: true
        },
        attack1: {
            image: $0bf05d3e3dd37f6f$var$attackOneImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 4,
            frameDuration: 0.06,
            scale: 2,
            currentFrame: 0,
            anchor: {
                x: -60,
                y: -128
            },
            loop: false
        },
        attack2: {
            image: $0bf05d3e3dd37f6f$var$attackTwoImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 5,
            frameDuration: 0.06,
            scale: 2,
            currentFrame: 0,
            anchor: {
                x: -60,
                y: -128
            },
            loop: false
        },
        attack3: {
            image: $0bf05d3e3dd37f6f$var$attackThreeImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 4,
            frameDuration: 0.06,
            scale: 2,
            currentFrame: 0,
            anchor: {
                x: -60,
                y: -128
            },
            loop: false
        },
        dead: {
            image: $0bf05d3e3dd37f6f$var$deadImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 4,
            frameDuration: 0.06,
            scale: 2,
            currentFrame: 0,
            anchor: {
                x: -34,
                y: -128
            },
            loop: false
        }
    });
const $0bf05d3e3dd37f6f$export$fee48151a8cb9a26 = ()=>({
        attack1: {
            name: "attack1",
            damage: 40,
            radius: 50,
            offsetX: 65
        },
        attack2: {
            name: "attack2",
            damage: 60,
            radius: 50,
            offsetX: 65
        },
        attack3: {
            name: "attack3",
            damage: 30,
            radius: 40,
            offsetX: 65
        }
    });


class $4cf91475a1a5eb40$export$dd6c903903653546 extends (0, $321bee1b12e48a66$export$bc644a473284d944) {
    constructor(){
        super();
        this.addComponent(new (0, $67b456ed522530b1$export$2d9aa282ad3f9ac)(500, 500));
        this.addComponent(new (0, $3250075dfba4d6bd$export$babf5140de81ae32)(0, 0, 2));
        this.addComponent(new (0, $e05e29b0d9153877$export$99ca0c5cb670cc62)());
        this.addComponent(new (0, $5c349c439b942f5d$export$66edb15d531635b1)((0, $0bf05d3e3dd37f6f$export$b147f7238d68047)()));
        this.addComponent(new (0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797)("idle"));
        this.addComponent(new (0, $834cd050a1a16358$export$4e4f72cac9994c6)(100, 100));
        this.addComponent(new (0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e)(500, 500, 20));
        this.addComponent(new (0, $3d0318475a397300$export$4268a6ac59be30c1)(0, 1280, 500, 720));
        this.addComponent(new (0, $fc12afeb84cfb73e$export$53aca58b69afda2)((0, $0bf05d3e3dd37f6f$export$fee48151a8cb9a26)()));
    }
}



class $319877f23ce87d92$export$6e517b2886152fc3 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(layers = [], width = 1280){
        super();
        this.layers = layers;
        this.width = width;
    }
    getLayers() {
        return this.layers;
    }
    update() {
        this.layers.forEach((layer)=>{
            layer.offsetX -= layer.speed;
            if (layer.offsetX <= -this.width) layer.offsetX = 0;
        });
    }
}



class $a9d1e1ed6f378232$export$d7d82cf1aec4c838 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(layer){
        super();
        this.layer = layer;
    }
    getLayer() {
        return this.layer;
    }
}



const $2994bda9b5856a38$var$background1 = window.document.getElementById("background-1");
const $2994bda9b5856a38$var$background2 = window.document.getElementById("background-2");
const $2994bda9b5856a38$var$background3 = window.document.getElementById("background-3");
const $2994bda9b5856a38$var$background4 = window.document.getElementById("background-4");
const $2994bda9b5856a38$var$ground = window.document.getElementById("ground");
const $2994bda9b5856a38$var$offsetY = -200;
const $2994bda9b5856a38$var$backgroundLayers = [
    {
        image: $2994bda9b5856a38$var$background1,
        speed: 0.1,
        offsetX: 0,
        offsetY: $2994bda9b5856a38$var$offsetY
    },
    {
        image: $2994bda9b5856a38$var$background2,
        speed: 0.2,
        offsetX: 0,
        offsetY: $2994bda9b5856a38$var$offsetY
    },
    {
        image: $2994bda9b5856a38$var$background3,
        speed: 0.3,
        offsetX: 0,
        offsetY: $2994bda9b5856a38$var$offsetY
    },
    {
        image: $2994bda9b5856a38$var$background4,
        speed: 0.4,
        offsetX: 0,
        offsetY: $2994bda9b5856a38$var$offsetY
    }
];
const $2994bda9b5856a38$var$groundLayer = {
    image: $2994bda9b5856a38$var$ground,
    speed: 1,
    offsetX: 0,
    offsetY: 150
};
class $2994bda9b5856a38$export$115867e63946cca5 extends (0, $321bee1b12e48a66$export$bc644a473284d944) {
    constructor(){
        super();
        this.addComponent(new (0, $319877f23ce87d92$export$6e517b2886152fc3)($2994bda9b5856a38$var$backgroundLayers));
        this.addComponent(new (0, $a9d1e1ed6f378232$export$d7d82cf1aec4c838)($2994bda9b5856a38$var$groundLayer));
    }
}



class $e512fe1c998ce7a6$export$7bff12cf3ce21399 extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.state = "chasing";
        this.timeSinceLastAttack = Infinity;
        this.attackCooldown = 2;
        this.timeSinceLastStateChange = Infinity;
        this.changeStateCooldown = 1;
    }
    getState() {
        return this.state;
    }
    changeState(state) {
        if (state === "attacking") {
            if (this.timeSinceLastAttack < this.attackCooldown) // attack on cooldown
            return;
            this.timeSinceLastAttack = 0;
        }
        if (state !== "dead" && this.timeSinceLastStateChange < this.changeStateCooldown) return;
        this.state = state;
        this.timeSinceLastStateChange = 0;
    }
    update(deltaTime) {
        this.timeSinceLastAttack += deltaTime;
        this.timeSinceLastStateChange += deltaTime;
    }
}



class $0501ecb051e76077$export$e1dae5660003ffa7 {
}


class $34476a9bc85b3bb0$export$5bae78c8af9ac077 extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    update(entities) {
        entities.forEach((entity)=>{
            const ai = entity.getComponent((0, $e512fe1c998ce7a6$export$7bff12cf3ce21399));
            const state = entity.getComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797));
            if (!ai || !state) return;
            const aiState = ai.getState();
            if (state.getState() === "dead") // change ai state to dead if entity died
            ai.changeState("dead");
            switch(aiState){
                case "idle":
                    state.changeState("idle");
                    break;
                case "chasing":
                case "retreating":
                    state.changeState("walk");
                    break;
                case "attacking":
                    state.changeState(this.pickRandomAttack());
                    break;
            }
        });
        return;
    }
    pickRandomAttack() {
        const attacks = [
            "attack1",
            "attack2",
            "attack3"
        ];
        return attacks[Math.floor(Math.random() * attacks.length)];
    }
}







class $0ec57ae3ccf0432e$export$1df5c89a5d722120 {
    constructor(){
        this.score = 0;
        this.enemiesKilled = 0;
        this.enemiesAlive = 0;
        this.maxEnemies = 10;
        this.spawnRate = 1;
        this.boundaries = {
            minX: 0,
            maxX: 1280,
            minY: 500,
            maxY: 720
        };
        this.AIConfig = {
            playerDetectionRadius: 150,
            enemyDetectionRadius: 100,
            attackProbability: 0.1
        };
    }
    static getInstance() {
        if (!$0ec57ae3ccf0432e$export$1df5c89a5d722120.instance) $0ec57ae3ccf0432e$export$1df5c89a5d722120.instance = new $0ec57ae3ccf0432e$export$1df5c89a5d722120();
        return $0ec57ae3ccf0432e$export$1df5c89a5d722120.instance;
    }
    getScore() {
        return this.score;
    }
    getEnemiesKilled() {
        return this.enemiesKilled;
    }
    getEnemiesAlive() {
        return this.enemiesAlive;
    }
    getMaxEnemies() {
        return this.maxEnemies;
    }
    getSpawnRate() {
        return this.spawnRate;
    }
    spawnEnemy() {
        this.enemiesAlive++;
    }
    killEnemy() {
        this.enemiesKilled++;
        this.enemiesAlive--;
        this.score += 100;
        if (this.enemiesKilled % 5 === 0) {
            this.maxEnemies++;
            this.spawnRate *= 0.9;
        }
    }
    getBoundaries() {
        return this.boundaries;
    }
    getAIConfig() {
        return this.AIConfig;
    }
}



class $db2928badeb63d8f$export$57f575acaa406022 extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(player){
        super();
        this.player = player;
    }
    update(entities, deltaTime) {
        const playerPosition = this.player.getComponent((0, $67b456ed522530b1$export$2d9aa282ad3f9ac));
        if (!playerPosition) return;
        const aiConfig = (0, $0ec57ae3ccf0432e$export$1df5c89a5d722120).getInstance().getAIConfig();
        entities.forEach((entity)=>{
            // Do AI stuff
            const ai = entity.getComponent((0, $e512fe1c998ce7a6$export$7bff12cf3ce21399));
            const position = entity.getComponent((0, $67b456ed522530b1$export$2d9aa282ad3f9ac));
            const collider = entity.getComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e));
            const velocity = entity.getComponent((0, $3250075dfba4d6bd$export$babf5140de81ae32));
            const state = entity.getComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797));
            if (!ai || !position || !velocity || !state || !collider) return;
            ai.update(deltaTime);
            const aiState = ai.getState();
            const playerInRange = this.playerInRange(position, playerPosition, aiConfig);
            const otherAIInTheWay = this.otherAIInTheWay(position, velocity, playerPosition, entities, aiConfig);
            if (aiState === "attacking" && state.getState() === "idle") {
                ai.changeState("idle");
                return;
            }
            switch(aiState){
                case "idle":
                    this.handleIdleState(ai, playerInRange, otherAIInTheWay, aiConfig);
                    break;
                case "chasing":
                    this.handleChasingState(ai, playerInRange, otherAIInTheWay, position, velocity, playerPosition);
                    break;
                case "attacking":
                case "dead":
                    break;
            }
        });
    }
    handleIdleState(ai, playerInRange, otherAIInTheWay, aiConfig) {
        if (!playerInRange && !otherAIInTheWay) {
            ai.changeState("chasing");
            return;
        }
        if (!playerInRange) return;
        if (Math.random() <= aiConfig.attackProbability) {
            ai.changeState("attacking");
            return;
        }
    }
    handleChasingState(ai, playerInRange, otherAIInTheWay, position, velocity, playerPosition) {
        if (playerInRange) {
            velocity.dx = 0;
            velocity.dy = 0;
            ai.changeState("idle");
            return;
        }
        if (otherAIInTheWay) {
            velocity.dx = 0;
            velocity.dy = 0;
            ai.changeState("idle");
            return;
        }
        this.moveTowardsPlayer(position, velocity, playerPosition);
    }
    playerInRange(position, playerPosition, aiConfig) {
        const dx = playerPosition.x - position.x;
        const dy = playerPosition.y - position.y;
        return Math.hypot(dy, dx) <= aiConfig.playerDetectionRadius;
    }
    moveTowardsPlayer(position, velocity, playerPosition) {
        const dx = playerPosition.x - position.x;
        const dy = playerPosition.y - position.y;
        const distance = Math.hypot(dy, dx);
        const directionX = dx / distance;
        const directionY = dy / distance;
        velocity.dx = directionX * velocity.speed;
        velocity.dy = directionY * velocity.speed;
    }
    otherAIInTheWay(position, velocity, playerPosition, entities, aiConfig) {
        return entities.some((entity)=>{
            const otherPosition = entity.getComponent((0, $67b456ed522530b1$export$2d9aa282ad3f9ac));
            const otherCollider = entity.getComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e));
            if (!otherPosition || !otherCollider || otherPosition.id === position.id || otherPosition.id === playerPosition.id) return false;
            // calculate the direction towards the player
            const dx = playerPosition.x - position.x;
            const dy = playerPosition.y - position.y;
            const distance = Math.hypot(dy, dx);
            const directionX = dx / distance;
            const directionY = dy / distance;
            const tempCollider = new (0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e)(position.x + directionX * velocity.speed, position.y + directionY * velocity.speed, aiConfig.enemyDetectionRadius);
            if (tempCollider.isColliding(otherCollider)) return true;
        });
    }
}




class $14cb55925a88bdc3$export$8625b16163591f05 extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    update(entities, deltaTime) {
        const animatedEntities = entities.filter((entity)=>{
            return entity.hasComponent((0, $5c349c439b942f5d$export$66edb15d531635b1));
        });
        animatedEntities.forEach((entity)=>{
            const animatedSprite = entity.getComponent((0, $5c349c439b942f5d$export$66edb15d531635b1));
            if (!animatedSprite) return;
            const animation = animatedSprite.getAnimation();
            if (!animation) return;
            animatedSprite.elapsedTime += deltaTime;
            if (animatedSprite.elapsedTime >= animation.frameDuration) {
                animatedSprite.elapsedTime = 0;
                animation.currentFrame++;
                if (animation.currentFrame >= animation.frameCount) {
                    if (animation.loop) animation.currentFrame = 0;
                    else animation.currentFrame = animation.frameCount - 1;
                }
            }
        });
    }
}





class $b7857a0daf7f5cc7$export$6b9e1e00681c120c extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    get damagedEntities() {
        return this._damagedEntities;
    }
    constructor(owner, damage){
        super();
        this.owner = owner;
        this.damage = damage;
        this._damagedEntities = [];
    }
    addDamagedEntity(entity) {
        this._damagedEntities.push(entity);
    }
}



class $a34170c1b56d3f39$export$27f565496e6d59cb extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(sounds, volume, loop){
        super();
        this.sounds = sounds;
        this.volume = volume;
        this.loop = loop;
    }
    getSound(key) {
        var _a;
        return (_a = this.sounds.get(key)) !== null && _a !== void 0 ? _a : "";
    }
}




class $8629e045cee6157d$export$eabd1914e389fced extends (0, $e823b32e1df697e6$export$16fa2f45be04daa8) {
    constructor(ttl){
        super();
        this.elapsedTime = 0;
        this.expireAt = 0;
        this.expireAt = ttl;
    }
    get isExpired() {
        return this.elapsedTime >= this.expireAt;
    }
    update(deltaTime) {
        this.elapsedTime += deltaTime;
    }
    expire() {
        this.elapsedTime = this.expireAt;
    }
}




const $7c4a8bfc08917105$var$sounds = ()=>new Map([
        [
            "hit",
            "sounds/hit.wav"
        ],
        [
            "miss",
            "sounds/miss.wav"
        ]
    ]);
class $7c4a8bfc08917105$export$cf7b81c15d0e241f extends (0, $321bee1b12e48a66$export$bc644a473284d944) {
    constructor(x, y, radius, duration, owner, damage){
        super();
        this.addComponent(new (0, $67b456ed522530b1$export$2d9aa282ad3f9ac)(x, y));
        this.addComponent(new (0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e)(x, y, radius));
        this.addComponent(new (0, $b7857a0daf7f5cc7$export$6b9e1e00681c120c)(owner, damage));
        this.addComponent(new (0, $8629e045cee6157d$export$eabd1914e389fced)(duration));
        this.addComponent(new (0, $a34170c1b56d3f39$export$27f565496e6d59cb)($7c4a8bfc08917105$var$sounds(), 1, false));
    }
}






class $ce845422b270f7d2$export$6713b04a771cceeb extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(engine){
        super();
        this.engine = engine;
    }
    update(entities, deltaTime) {
        entities.forEach((entity)=>{
            this.createAttack(entity, deltaTime);
            this.updateAttack(entity);
        });
    }
    createAttack(entity, deltaTime) {
        var _a;
        const position = entity.getComponent((0, $67b456ed522530b1$export$2d9aa282ad3f9ac));
        const state = entity.getComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797));
        if (!position || !state) return;
        if (state.isAttacking() && state.canAttack()) {
            const attack = (_a = entity.getComponent((0, $fc12afeb84cfb73e$export$53aca58b69afda2))) === null || _a === void 0 ? void 0 : _a.getAttack(state.getState());
            if (!attack) return;
            const direction = state.getDirection();
            const attackDirection = direction === "left" ? -1 : 1;
            this.engine.addEntity(new (0, $7c4a8bfc08917105$export$cf7b81c15d0e241f)(position.x + attack.offsetX * attackDirection, position.y, attack.radius, 1, entity, attack.damage));
        }
        state.update(deltaTime);
    }
    updateAttack(entity) {
        const attack = entity.getComponent((0, $b7857a0daf7f5cc7$export$6b9e1e00681c120c));
        const lifespan = entity.getComponent((0, $8629e045cee6157d$export$eabd1914e389fced));
        if (!attack || !lifespan) return;
        const ownerState = attack.owner.getComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797));
        if (!ownerState) return;
        if (!ownerState.isAttacking()) lifespan.expire();
    }
}





class $8221235cfeb7dd3e$export$6aa4c270896a9dcc extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(context){
        super();
        this.context = context;
    }
    update(entities) {
        this.clear();
        entities.forEach((entity)=>{
            const background = entity.getComponent((0, $319877f23ce87d92$export$6e517b2886152fc3));
            const ground = entity.getComponent((0, $a9d1e1ed6f378232$export$d7d82cf1aec4c838));
            if (background) {
                background.getLayers().forEach((layer)=>{
                    this.render(layer);
                });
                background.update();
            }
            if (ground) this.render(ground.getLayer());
        });
    }
    render(layer) {
        this.context.drawImage(layer.image, layer.offsetX, layer.offsetY, this.context.canvas.width, this.context.canvas.height);
        this.context.drawImage(layer.image, layer.offsetX + this.context.canvas.width - 2, layer.offsetY, this.context.canvas.width, this.context.canvas.height);
    }
    clear() {
        this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
    }
}




class $4a21015654b766f8$export$91c0d54cdac46d25 extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(context){
        super();
        this.context = context;
    }
    update(entities) {
        entities.forEach((entity)=>{
            const collider = entity.getComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e));
            if (!collider) return;
            const { x: x, y: y, radius: radius } = collider;
            this.context.beginPath();
            this.context.arc(x, y, radius, 0, 2 * Math.PI);
            this.context.stroke();
        });
    }
}













const $aafe1cf5d93f6d62$var$idleImage = window.document.getElementById("enemy-idle");
const $aafe1cf5d93f6d62$var$walkImage = window.document.getElementById("enemy-walk");
const $aafe1cf5d93f6d62$var$deadImage = window.document.getElementById("enemy-dead");
const $aafe1cf5d93f6d62$var$attackOneImage = window.document.getElementById("enemy-attack-1");
const $aafe1cf5d93f6d62$var$attackTwoImage = window.document.getElementById("enemy-attack-2");
const $aafe1cf5d93f6d62$var$attackThreeImage = window.document.getElementById("enemy-attack-3");
const $aafe1cf5d93f6d62$export$579d44585540d8b5 = ()=>({
        idle: {
            image: $aafe1cf5d93f6d62$var$idleImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 6,
            frameDuration: 0.06,
            scale: 1.7,
            currentFrame: 0,
            anchor: {
                x: -72,
                y: -128
            },
            loop: true
        },
        walk: {
            image: $aafe1cf5d93f6d62$var$walkImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 8,
            frameDuration: 0.06,
            scale: 1.7,
            currentFrame: 0,
            anchor: {
                x: -64,
                y: -128
            },
            loop: true
        },
        dead: {
            image: $aafe1cf5d93f6d62$var$deadImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 6,
            frameDuration: 0.06,
            scale: 1.7,
            currentFrame: 0,
            anchor: {
                x: -64,
                y: -128
            },
            loop: false
        },
        attack1: {
            image: $aafe1cf5d93f6d62$var$attackOneImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 6,
            frameDuration: 0.06,
            scale: 1.7,
            currentFrame: 0,
            anchor: {
                x: -64,
                y: -128
            },
            loop: false
        },
        attack2: {
            image: $aafe1cf5d93f6d62$var$attackTwoImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 4,
            frameDuration: 0.06,
            scale: 1.7,
            currentFrame: 0,
            anchor: {
                x: -64,
                y: -128
            },
            loop: false
        },
        attack3: {
            image: $aafe1cf5d93f6d62$var$attackThreeImage,
            frameWidth: 128,
            frameHeight: 128,
            frameCount: 3,
            frameDuration: 0.06,
            scale: 1.7,
            currentFrame: 0,
            anchor: {
                x: -64,
                y: -128
            },
            loop: false
        }
    });
const $aafe1cf5d93f6d62$export$c9b3a4274a91fb0f = ()=>({
        attack1: {
            name: "attack1",
            damage: 10,
            radius: 50,
            offsetX: 50
        },
        attack2: {
            name: "attack2",
            damage: 20,
            radius: 50,
            offsetX: 50
        },
        attack3: {
            name: "attack3",
            damage: 30,
            radius: 50,
            offsetX: 50
        }
    });



class $744a580351940046$export$2a721c5e92751912 extends (0, $321bee1b12e48a66$export$bc644a473284d944) {
    constructor(x, y){
        super();
        this.addComponent(new (0, $67b456ed522530b1$export$2d9aa282ad3f9ac)(x, y));
        this.addComponent(new (0, $3250075dfba4d6bd$export$babf5140de81ae32)(0, 0, 1));
        this.addComponent(new (0, $5c349c439b942f5d$export$66edb15d531635b1)((0, $aafe1cf5d93f6d62$export$579d44585540d8b5)()));
        this.addComponent(new (0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797)("idle"));
        this.addComponent(new (0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e)(x, y, 20));
        this.addComponent(new (0, $834cd050a1a16358$export$4e4f72cac9994c6)(100, 100));
        this.addComponent(new (0, $fc12afeb84cfb73e$export$53aca58b69afda2)((0, $aafe1cf5d93f6d62$export$c9b3a4274a91fb0f)()));
        this.addComponent(new (0, $e512fe1c998ce7a6$export$7bff12cf3ce21399)());
        this.addComponent(new (0, $3d0318475a397300$export$4268a6ac59be30c1)(0, 1280, 500, 720));
    }
}



class $f7ecf35cf90dbbe5$export$f7c29c90af669cdc extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(engine){
        super();
        this.engine = engine;
        this.lastSpawnTime = Infinity;
    }
    update(entities, deltaTime) {
        this.lastSpawnTime += deltaTime;
        const gameManager = (0, $0ec57ae3ccf0432e$export$1df5c89a5d722120).getInstance();
        if (this.lastSpawnTime < gameManager.getSpawnRate()) return;
        if (gameManager.getEnemiesAlive() >= gameManager.getMaxEnemies()) return;
        this.lastSpawnTime = 0;
        const [x, y] = this.findSpawnLocation(entities, gameManager);
        if (!x || !y) return;
        this.engine.addEntity(new (0, $744a580351940046$export$2a721c5e92751912)(x, y));
        gameManager.spawnEnemy();
    }
    findSpawnLocation(entities, gameManager) {
        let locationFound = false;
        let candidateX = 0;
        let candidateY = 0;
        let maxTries = 100;
        const boundaries = gameManager.getBoundaries();
        const aiConfig = gameManager.getAIConfig();
        while(!locationFound && maxTries > 0){
            candidateX = Math.random() * boundaries.maxX * 0.25 + boundaries.maxX + 200;
            candidateY = Math.random() * (boundaries.maxY - boundaries.minY) + boundaries.minY;
            if (Math.random() < 0.5) candidateX = -candidateX;
            locationFound = entities.every((entity)=>{
                const position = entity.getComponent((0, $67b456ed522530b1$export$2d9aa282ad3f9ac));
                if (!position) return true;
                const dx = position.x - candidateX;
                const dy = position.y - candidateY;
                const distance = Math.hypot(dx, dy);
                maxTries--;
                return distance > aiConfig.enemyDetectionRadius * 2;
            });
        }
        return maxTries > 0 ? [
            candidateX,
            candidateY
        ] : [
            null,
            null
        ];
    }
}




class $bf35ed3743098818$export$fcc3d55ccbee51a4 extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(context){
        super();
        this.context = context;
    }
    update() {
        const gameManager = (0, $0ec57ae3ccf0432e$export$1df5c89a5d722120).getInstance();
        this.context.save();
        this.context.font = "24px Arial";
        this.context.fillText(`Score: ${gameManager.getScore()}`, 10, 30);
        this.context.fillText(`Kills: ${gameManager.getEnemiesKilled()}`, 10, 60);
        this.context.restore();
    }
}





class $baa3953161f9f3d4$export$8984d439a6629dc extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(context){
        super();
        this.context = context;
    }
    update(entites) {
        entites.forEach((entity)=>{
            const health = entity.getComponent((0, $834cd050a1a16358$export$4e4f72cac9994c6));
            const position = entity.getComponent((0, $67b456ed522530b1$export$2d9aa282ad3f9ac));
            if (!health || !position) return;
            this.render(position, health);
        });
    }
    render(position, health) {
        this.context.fillText(`${health.currentHealth}/${health.maxHealth}`, position.x - 24, position.y - 158);
    }
}






class $1577c6f1835cb9fb$export$a4b27ad55a9789a extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    update(entities) {
        entities.forEach((entity)=>{
            const health = entity.getComponent((0, $834cd050a1a16358$export$4e4f72cac9994c6));
            const state = entity.getComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797));
            const aiState = entity.getComponent((0, $e512fe1c998ce7a6$export$7bff12cf3ce21399));
            if (health === null || health === void 0 ? void 0 : health.isDead()) {
                state === null || state === void 0 || state.changeState("dead");
                aiState === null || aiState === void 0 || aiState.changeState("dead");
            }
        });
    }
}








class $82c05cb1b9068dd7$export$557a8016f4e0c1ba {
    constructor(){
        this.audioCache = new Map();
        this.globalVolume = 1;
    }
    static getInstance() {
        if (!$82c05cb1b9068dd7$export$557a8016f4e0c1ba.instance) $82c05cb1b9068dd7$export$557a8016f4e0c1ba.instance = new $82c05cb1b9068dd7$export$557a8016f4e0c1ba();
        return $82c05cb1b9068dd7$export$557a8016f4e0c1ba.instance;
    }
    setVolume(number) {
        // set volume to value between 0 and 1
        this.globalVolume = Math.min(1, Math.max(0, number));
    }
    playSound(path, volume = 1, loop = false) {
        const audio = this.getAudio(path);
        audio.volume = volume * this.globalVolume;
        audio.currentTime = 0;
        audio.loop = loop;
        audio.play().catch((error)=>{
            console.error(`Failed to play audio: ${path}`, error);
        });
    }
    getAudio(path) {
        if (!this.audioCache.has(path)) {
            const audio = new Audio(path);
            this.audioCache.set(path, audio);
        }
        return this.audioCache.get(path);
    }
}


class $a81346bfc7520b49$export$312079d0ff8e4d4b extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    update(entities) {
        const collisionEntities = entities.filter((entity)=>{
            return entity.hasComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e)) && entity.hasComponent((0, $834cd050a1a16358$export$4e4f72cac9994c6));
        });
        entities.forEach((attackEntity)=>{
            const attackDamage = attackEntity.getComponent((0, $b7857a0daf7f5cc7$export$6b9e1e00681c120c));
            const attack = attackEntity.getComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e));
            const attackSound = attackEntity.getComponent((0, $a34170c1b56d3f39$export$27f565496e6d59cb));
            if (!attack || !attackDamage || !attackSound) return;
            const ownerState = attackDamage.owner.getComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797));
            if (!ownerState || !ownerState.isAttacking()) return;
            collisionEntities.forEach((collisionEntity)=>{
                const collision = collisionEntity.getComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e));
                const health = collisionEntity.getComponent((0, $834cd050a1a16358$export$4e4f72cac9994c6));
                if (!collision || !health) return;
                // don't hit attack itself
                if (attackEntity === collisionEntity) return;
                // don't hit attack's owner
                if ((attackDamage === null || attackDamage === void 0 ? void 0 : attackDamage.owner) === collisionEntity) return;
                // don't hit already damaged entities
                if (attackDamage.damagedEntities.includes(collisionEntity)) return;
                if (attack.isColliding(collision)) {
                    (0, $82c05cb1b9068dd7$export$557a8016f4e0c1ba).getInstance().playSound(attackSound.getSound("hit"));
                    health.takeDamage(attackDamage.damage);
                } else (0, $82c05cb1b9068dd7$export$557a8016f4e0c1ba).getInstance().playSound(attackSound.getSound("miss"));
                attackDamage.addDamagedEntity(collisionEntity);
            });
        });
    }
}






class $459647b5e59d9d02$export$f5bef322f002c274 extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    update(entities) {
        const inputEntities = entities.filter((entity)=>entity.hasComponent((0, $e05e29b0d9153877$export$99ca0c5cb670cc62)) && entity.hasComponent((0, $3250075dfba4d6bd$export$babf5140de81ae32)) && entity.hasComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797)));
        inputEntities.forEach((entity)=>{
            const input = entity.getComponent((0, $e05e29b0d9153877$export$99ca0c5cb670cc62));
            const velocity = entity.getComponent((0, $3250075dfba4d6bd$export$babf5140de81ae32));
            const state = entity.getComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797));
            if (!input || !velocity || !state) return;
            velocity.dx = 0;
            velocity.dy = 0;
            const lastKey = input.getLastKey();
            switch(lastKey){
                case "j":
                    state.changeState("attack1");
                    break;
                case "k":
                    state.changeState("attack2");
                    break;
                case "l":
                    state.changeState("attack3");
                    break;
            }
            if (state.isAttacking()) return;
            if (input.isKeyDown("w")) velocity.dy = -velocity.speed;
            if (input.isKeyDown("s")) velocity.dy = velocity.speed;
            if (input.isKeyDown("a")) velocity.dx = -velocity.speed;
            if (input.isKeyDown("d")) velocity.dx = velocity.speed;
        });
    }
}




class $bc71c50dd3fe0674$export$50502b96c26166ea extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(engine){
        super();
        this.engine = engine;
        window.addEventListener("keydown", (event)=>{
            this.keyEventHandler(event.key, "down");
        });
        window.addEventListener("keyup", (event)=>{
            this.keyEventHandler(event.key, "up");
        });
    }
    keyEventHandler(key, eventType) {
        const inputEntities = this.engine.entities.filter((entity)=>{
            return entity.hasComponent((0, $e05e29b0d9153877$export$99ca0c5cb670cc62));
        });
        const state = eventType === "down" ? true : false;
        inputEntities.forEach((entity)=>{
            const input = entity.getComponent((0, $e05e29b0d9153877$export$99ca0c5cb670cc62));
            if (!input) return;
            input.setKeyState(key, state);
        });
    }
    update() {}
}




class $92dcdb6e9cbf506a$export$e5bd7593c84d766e extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(engine){
        super();
        this.engine = engine;
    }
    update(entities, deltaTime) {
        entities.forEach((entity)=>{
            const lifespan = entity.getComponent((0, $8629e045cee6157d$export$eabd1914e389fced));
            if (!lifespan) return;
            lifespan.update(deltaTime);
            if (lifespan.isExpired) this.engine.removeEntity(entity);
        });
    }
}








class $ea062e376f60f092$export$8463c66827c6b0ce extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    update(entities) {
        const collisionEntities = entities.filter((entity)=>{
            return entity.hasComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e)) && entity.hasComponent((0, $3250075dfba4d6bd$export$babf5140de81ae32));
        });
        entities.forEach((entity)=>{
            const position = entity.getComponent((0, $67b456ed522530b1$export$2d9aa282ad3f9ac));
            const velocity = entity.getComponent((0, $3250075dfba4d6bd$export$babf5140de81ae32));
            const collider = entity.getComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e));
            const boundary = entity.getComponent((0, $3d0318475a397300$export$4268a6ac59be30c1));
            const ai = entity.getComponent((0, $e512fe1c998ce7a6$export$7bff12cf3ce21399));
            if (!position || !velocity || !collider) return;
            if (boundary && !boundary.isInBoundary(position.x + velocity.dx, position.y + velocity.dy) && !ai) return;
            collider.x += velocity.dx;
            collider.y += velocity.dy;
            if (this.collidesWithOtherEntity(collider, collisionEntities)) {
                collider.x = position.x;
                collider.y = position.y;
                return;
            }
            position.x = collider.x;
            position.y = collider.y;
        });
    }
    collidesWithOtherEntity(self, others) {
        let isColliding = false;
        others.forEach((other)=>{
            const collider = other.getComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e));
            if (!collider) return;
            if (collider === self) return;
            if (self.isColliding(collider)) isColliding = true;
        });
        return isColliding;
    }
}






class $ebc50dd14bab73a5$export$ba467a02410f8d7a extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    constructor(context){
        super();
        this.context = context;
    }
    update(entities) {
        const renderingStack = [];
        entities.forEach((entity)=>{
            const position = entity.getComponent((0, $67b456ed522530b1$export$2d9aa282ad3f9ac));
            const animatedSprite = entity.getComponent((0, $5c349c439b942f5d$export$66edb15d531635b1));
            const state = entity.getComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797));
            if (!position || !animatedSprite || !state) return;
            renderingStack.push({
                position: position,
                sprite: animatedSprite.getAnimation(),
                mirror: animatedSprite.mirror
            });
        });
        renderingStack.sort((a, b)=>a.position.y - b.position.y);
        renderingStack.forEach(({ position: position, sprite: sprite, mirror: mirror })=>{
            this.render(position, sprite, mirror);
        });
    }
    render(position, sprite, mirror = false) {
        if (!sprite) return;
        this.context.save();
        if (mirror) {
            this.context.scale(-1, 1);
            position.x *= -1;
        }
        this.context.drawImage(sprite.image, sprite.currentFrame * sprite.frameWidth, 0, sprite.frameWidth, sprite.frameHeight, position.x + sprite.anchor.x * sprite.scale, position.y + sprite.anchor.y * sprite.scale, sprite.frameWidth * sprite.scale, sprite.frameHeight * sprite.scale);
        if (mirror) position.x *= -1;
        this.context.restore();
    }
}









class $068db51f1d74ae38$export$d47ea6626863db49 extends (0, $0501ecb051e76077$export$e1dae5660003ffa7) {
    update(entities) {
        const gameManager = (0, $0ec57ae3ccf0432e$export$1df5c89a5d722120).getInstance();
        entities.forEach((entity)=>{
            const state = entity.getComponent((0, $f3338545e23e2b8f$export$36b8b2bbc6a3b797));
            if (!state) return;
            const animation = entity.getComponent((0, $5c349c439b942f5d$export$66edb15d531635b1));
            const velocity = entity.getComponent((0, $3250075dfba4d6bd$export$babf5140de81ae32));
            this.cleanup(entity, state, gameManager);
            this.updateAnimation(state, animation);
            this.updateMovement(state, animation, velocity);
        });
    }
    updateAnimation(state, animation) {
        if (animation) animation.changeAnimation(state.getState(), state.getDirection());
    }
    updateMovement(state, animation, velocity) {
        if (!animation || !velocity) return;
        // change to walk if moving
        if (velocity.isMoving()) {
            state.changeState("walk", velocity.direction());
            return;
        }
        if (state.isAttacking() && !animation.isDone()) return;
        if (state.getState() === "dead") return;
        state.changeState("idle");
    }
    cleanup(entity, state, gameManager) {
        if (state.getState() !== "dead" || entity.hasComponent((0, $8629e045cee6157d$export$eabd1914e389fced))) // only kill entities that are not already dead
        return;
        entity.removeComponent((0, $3250075dfba4d6bd$export$babf5140de81ae32));
        entity.removeComponent((0, $805f1743fe3f6d72$export$3c9e91dc1b611d2e));
        entity.addComponent(new (0, $8629e045cee6157d$export$eabd1914e389fced)(5));
        gameManager.killEnemy();
    }
}


class $181cedf503646581$export$2c3b404bf3a77a1f {
    constructor(){
        this.entities = [];
        this.systems = [];
    }
    addEntity(entity) {
        this.entities.push(entity);
        return entity;
    }
    removeEntity(entity) {
        this.entities = this.entities.filter((e)=>e.id !== entity.id);
    }
    addSystem(system) {
        this.systems.push(system);
    }
    update(deltaTime) {
        this.systems.forEach((system)=>{
            system.update(this.entities, deltaTime);
        });
    }
}


class $5f0d8cc1cacb4f77$export$c33317e0a62b8bbb {
    constructor(context, debug = false){
        this.context = context;
        this.lastTime = 0;
        this.engine = new (0, $181cedf503646581$export$2c3b404bf3a77a1f)();
        this.engine.addEntity(new (0, $2994bda9b5856a38$export$115867e63946cca5)());
        this.player = this.engine.addEntity(new (0, $4cf91475a1a5eb40$export$dd6c903903653546)());
        this.engine.addSystem(new (0, $f7ecf35cf90dbbe5$export$f7c29c90af669cdc)(this.engine));
        this.engine.addSystem(new (0, $bc71c50dd3fe0674$export$50502b96c26166ea)(this.engine));
        this.engine.addSystem(new (0, $459647b5e59d9d02$export$f5bef322f002c274)());
        this.engine.addSystem(new (0, $db2928badeb63d8f$export$57f575acaa406022)(this.player));
        this.engine.addSystem(new (0, $34476a9bc85b3bb0$export$5bae78c8af9ac077)());
        this.engine.addSystem(new (0, $ea062e376f60f092$export$8463c66827c6b0ce)());
        this.engine.addSystem(new (0, $ce845422b270f7d2$export$6713b04a771cceeb)(this.engine));
        this.engine.addSystem(new (0, $14cb55925a88bdc3$export$8625b16163591f05)());
        this.engine.addSystem(new (0, $a81346bfc7520b49$export$312079d0ff8e4d4b)());
        this.engine.addSystem(new (0, $92dcdb6e9cbf506a$export$e5bd7593c84d766e)(this.engine));
        this.engine.addSystem(new (0, $1577c6f1835cb9fb$export$a4b27ad55a9789a)());
        this.engine.addSystem(new (0, $068db51f1d74ae38$export$d47ea6626863db49)());
        this.engine.addSystem(new (0, $8221235cfeb7dd3e$export$6aa4c270896a9dcc)(this.context));
        if (debug) this.engine.addSystem(new (0, $4a21015654b766f8$export$91c0d54cdac46d25)(this.context));
        this.engine.addSystem(new (0, $ebc50dd14bab73a5$export$ba467a02410f8d7a)(this.context));
        this.engine.addSystem(new (0, $baa3953161f9f3d4$export$8984d439a6629dc)(this.context));
        this.engine.addSystem(new (0, $bf35ed3743098818$export$fcc3d55ccbee51a4)(this.context));
    }
    loop(time = 0) {
        const deltaTime = (time - this.lastTime) / 1000;
        this.engine.update(deltaTime);
        this.lastTime = time;
        requestAnimationFrame(this.loop.bind(this));
    }
}


const $f27a99974ce68c5f$var$DEBUG = false;
window.addEventListener("load", ()=>{
    const canvas = document.getElementById("canvas");
    if (!canvas) throw new Error("Canvas not found");
    canvas.width = 1280;
    canvas.height = 720;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Canvas context not found");
    ctx.strokeStyle = "red";
    ctx.fillStyle = "white";
    ctx.font = "12px Arial";
    new (0, $5f0d8cc1cacb4f77$export$c33317e0a62b8bbb)(ctx, $f27a99974ce68c5f$var$DEBUG).loop(0);
});


//# sourceMappingURL=index.eae55d2f.js.map
